// GATE2-ADD
import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import cytoscape from "cytoscape";
import CytoscapeComponent from "react-cytoscapejs";
import contextMenus from "cytoscape-context-menus";
import cola from "cytoscape-cola";
import navigator from "cytoscape-navigator";
import popper from "cytoscape-popper";
import "cytoscape-context-menus/cytoscape-context-menus.css";
import "./../../styles/cytoscape-navigator-styles.css";
import "./../../styles/cytoscape-popper-styles.css";
import "./../../styles/cytoscape-custom-menu-styles.css";
import { CssDataJacketButton } from "../../styles/styled";
import DataNetworkUsageGuide from "./dataNetworkUsageGuide";
import {
  getDataJacketNodeDetail,
  saveDataNetwork,
  getDataNetwork,
  getSavedDataNetwork,
} from "../../js/queriesHandling";
import { DataJacketSelectNodeModal } from "./dataJacketSelectNodeModal";
import { DataJacketComfirmModal } from "./dataJacketComfirmModal";
import { DataJacketComfirmModalUnfold } from "./dataJacketComfirmModalUnfold";
import { SendToMyConnectDj } from "./dataNetworkSendToMyConnectDj";
import DataNetworkDetailModal from "./dataNetworkDetailModal";
import { dataJacket, myDataJacketList } from "../../graphql/queries";
import { convertDateTimeToDate } from "../../js/stringHandling";
import { API, graphqlOperation } from "aws-amplify";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";

cytoscape.use(cola);
cytoscape.use(contextMenus);
cytoscape.use(popper);
navigator(cytoscape);

const layout = {
  name: "cola",
  fit: false,
  animate: true,
  ungrabifyWhileSimulating: false,
  avoidOverlap: true,
  avoidOverlapPadding: 2,
  centerGraph: true,
  nodeSpacing: function (node) {
    return 20;
  },
  maxSimulationTime: 1000,
  // different methods of specifying edge length
  // each can be a constant numerical value or a function like `function( edge ){ return 2; }`
  edgeLength: function (edge) {
    return 150;
  }, // sets edge length directly in simulation
  edgeSymDiffLength: undefined, // symmetric diff edge length in simulation
  edgeJaccardLength: undefined, // jaccard edge length in simulation
};

const preset = {
  name: "preset",
  fit: false,
  animate: false,
  ungrabifyWhileSimulating: false,
  avoidOverlap: true,
  avoidOverlapPadding: 2,
  centerGraph: true,
  nodeSpacing: function (node) {
    return 20;
  },
  maxSimulationTime: 500,
  // different methods of specifying edge length
  // each can be a constant numerical value or a function like `function( edge ){ return 2; }`
  edgeLength: function (edge) {
    return 150;
  }, // sets edge length directly in simulation
  edgeSymDiffLength: undefined, // symmetric diff edge length in simulation
  edgeJaccardLength: undefined, // jaccard edge length in simulation
  transform: function (node, position) {
    return position;
  },
};

const compnentStyle = {
  width: "97vw",
  height: "85vh",
  minWidth: "1200px",
  minHeight: "500px",
};
const stylesheet = [
  {
    selector: "node[level=1]",
    style: {
      label: "data(label)",
      width: 15,
      height: 15,
      backgroundColor: "#007CB0", //blue 5
      color: "white",
    },
  },
  {
    selector: "node[level=2]",
    style: {
      label: "data(label)",
      width: 15,
      height: 15,
      backgroundColor: "#43B02A", //deloitte green
      color: "white",
    },
  },
  {
    selector: "node[level=3]",
    style: {
      label: "data(label)",
      width: 15,
      height: 15,
      backgroundColor: "#63666A", //grey 11
      color: "white",
    },
  },
  {
    selector: "edge[line=1]",
    style: {
      width: 1,
      lineFill: "linear-gradient",
      lineGradientStopColors: ["white", "#63666A"], // yellow, orange, orange, red
      lineGradientStopPositions: ["0%", "70%"],
    },
  },
  {
    selector: "edge[line=2]",
    style: {
      width: 1.5,
      lineFill: "linear-gradient",
      lineGradientStopColors: ["white", "#BBBCBC"], // yellow, orange, orange, red
      lineGradientStopPositions: ["0%", "70%"],
    },
  },
  {
    selector: "edge[line=3]",
    style: {
      width: 2,
      lineFill: "linear-gradient",
      lineGradientStopColors: ["white", "#FFFF2D"], // yellow, orange, orange, red
      lineGradientStopPositions: ["0%", "70%"],
    },
  },
  {
    selector: "edge[line=4]",
    style: {
      width: 3,
      lineFill: "linear-gradient",
      lineGradientStopColors: ["#FFCD00", "#FFAA00"], // yellow, orange, orange, red
      lineGradientStopPositions: ["0%", "70%"],
    },
  },
  {
    selector: "edge[line=5]",
    style: {
      width: 4,
      lineFill: "linear-gradient",
      lineGradientStopColors: ["#FFCD00", "#DA291C"], // yellow, orange, orange, red
      lineGradientStopPositions: ["0%", "70%"],
    },
  },
  {
    selector: "node:selected",
    style: {
      borderStyle: "solid",
      borderColor: "#239df9",
      borderWidth: 2,
    },
  },
];

export default function NetworkMap({
  newFlag,
  setNew,
  displayFlag,
  setDisplay,
  mode,
  arrNetworkData,
  setNetworkData,
  setFoldNode,
  networkData,
  setNetworkDataStorage,
  networkDataStorage,
  foldNode,
  setFirstLoad,
  firstLoad,
  tempFlg,
  id,
  setName,
  setSummary,
  name,
  summary,
  visibleEdgeTypes,
  setVisibleEdgeTypes,
  setContinuousSaving,
  continuousSaving,
  setSavedId,
  savedId,
}) {
  const [tempNodeDataStorage, setTempNodeDataStorage] = React.useState([]);
  const [count, setCount] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [openComfirm, setOpenComfirm] = React.useState(false);
  const [openRegister, setOpenRegister] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(true);
  const [saveImage, setSaveImage] = React.useState("");
  const [select, setSelect] = React.useState(false);
  const [detail, setDetail] = React.useState("");
  const [myDetail, setMyDetail] = React.useState("");
  const [parent, setParent] = React.useState("");
  const [user, setUser] = React.useState("");
  const handleOpen = () => setOpen(true);
  const navigate = useNavigate();
  const myRef = React.useRef();
  const [nodeInfo, setNodeInfo] = React.useState([]);
  const [answerYes, setAnswerYes] = React.useState(false);
  const [answerNo, setAnswerNo] = React.useState(false);
  const [restoreflg, setRestoreflg] = React.useState(false);
  const [unfoldId, setUnfoldId] = React.useState("");
  const [layoutName, setLayoutName] = React.useState("");
  const [innerMode, setInnerMode] = React.useState("");

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser();
      setUser(data.username);
    } catch (err) {}
  }

  //Creater starter node (level 1)
  function createElements() {
    if (arrNetworkData.length > 0) {
      let tempNodeData = [];
      for (const data of arrNetworkData) {
        tempNodeData.push({
          data: {
            id: data.datajacketId,
            label: data.value,
            level: 1,
            expand: 0,
          },
        });
      }
      setNetworkData(tempNodeData);
      setNetworkDataStorage(tempNodeData);
      setTempNodeDataStorage(tempNodeData);
      setLayoutName(layout);
    }
  }

  const recover = () => {
    setVisibleEdgeTypes((prevData) => ({
      ...prevData, // 既存のデータを展開してコピー
      checkbox1: "type1", // 特定のキーに新しい値を代入
      checkbox2: "type2",
      checkbox3: "type3",
      checkbox4: "type4",
      checkbox5: "type5",
    }));
  };

  //Save Data Network
  function handleSave() {
    let saveNetworkName = "temp"; // Can be change from temp to custom name
    let saveCommand = "temp"; // Can be change from temp to new or edit
    myRef.current.elements("node").lock();

    if (user !== undefined && user != "" && networkData.length > 0) {
      saveDataNetwork(
        user,
        saveNetworkName,
        "",
        saveCommand,
        JSON.stringify({
          networkData: setNodePosition1(networkData),
          foldData: foldNode,
        })
      );
      setNetworkData([]);

      myRef.current.stop();
      myRef.current.destroy();
    }
  }

  async function getTempData() {
    let result = await getDataNetwork(user);
    setFirstLoad(true);
    setLayoutName(preset);
    setNetworkData(JSON.parse(result).networkData);
    setFoldNode(JSON.parse(result).foldData);
  }

  //Get temporary saved Data Network Infomation (json)
  async function getTempData1() {
    try {
      let result = await getSavedDataNetwork(savedId);
      setFirstLoad(true);
      setLayoutName(preset);
      setNetworkData(JSON.parse(result.json_filtered).networkData);
      setFoldNode(JSON.parse(result.json_filtered).foldData);
      setVisibleEdgeTypes(JSON.parse(result.json_similarity));
      setNetworkDataStorage(JSON.parse(result.json_all));
    } catch {}
  }

  async function getTempData2() {
    try {
      myRef.current.elements("node").lock();
      let result = await getSavedDataNetwork(id);
      setFirstLoad(true);
      setLayoutName(preset);
      setNetworkData(JSON.parse(result.json_filtered).networkData);
      setFoldNode(JSON.parse(result.json_filtered).foldData);
      setVisibleEdgeTypes(JSON.parse(result.json_similarity));
      setNetworkDataStorage(JSON.parse(result.json_all));
    } catch {}
  }

  // Get nodes position and return the result
  function setNodePosition(rootData) {
    try {
      myRef.current.json().elements.nodes.forEach(function (ele) {
        const setPosition = rootData.find(
          (node) => node.data.id === ele.data.id
        );
        setPosition.position = {
          x: ele.position.x * myRef.current.zoom(),
          y: ele.position.y * myRef.current.zoom(),
        };
      });
      return rootData;
    } catch (e) {
      return 0;
    }
  }

  function setNodePosition1(rootData) {
    try {
      myRef.current.json().elements.nodes.forEach(function (ele) {
        const setPosition = rootData.find(
          (node) => node.data.id === ele.data.id
        );
        setPosition.position = {
          x: ele.position.x,
          y: ele.position.y,
        };
      });
      return rootData;
    } catch (e) {
      return 0;
    }
  }

  // Creat object -- can be reused anywhere
  function createObject(source, child) {
    try {
      var returnVal = [];
      for (let i = 0; i < source[child[0]].split(",").length; i++) {
        var childVal = {};
        for (let j = 0; j < child.length; j++) {
          childVal[child[j]] = source[child[j]].split(",")[i];
        }
        returnVal.push(childVal);
      }
      return returnVal;
    } catch (e) {}
  }

  // Sort object -- can be reused anywhere
  function sortObject(source, key, sort) {
    return sort === "desc"
      ? source.sort((a, b) => (a[key] < b[key] ? 1 : -1))
      : source.sort((a, b) => (a[key] > b[key] ? 1 : -1));
  }

  // Display nodes after select nodes
  function displayFilterNode(filterId) {
    let tempNodeData = [];
    var filterResult = nodeInfo.filter(({ node_ids }) =>
      filterId.includes(node_ids)
    );
    for (var i = 0; i < filterResult.length; i++) {
      if (
        networkData.filter((e) => e.data.id === filterResult[i].node_ids)
          .length > 0
      ) {
        // prevent existing node to be created
      } else if (filterResult[i].node_raw_datas === "true") {
        // add child nodes - level 2: have real data
        tempNodeData.push({
          data: {
            id: filterResult[i].node_ids,
            label: filterResult[i].node_names,
            parentId: parent,
            level: 2,
            expand: 0,
          },
        });
      } else {
        // add child nodes - level 3: have no real data
        tempNodeData.push({
          data: {
            id: filterResult[i].node_ids,
            label: filterResult[i].node_names,
            parentId: parent,
            level: 3,
            expand: 0,
          },
        });
      }
      // add edges
      for (let j = 1; j < 6; j++) {
        if (filterResult[i].node_similarity < 0.2 * j || j === 5) {
          tempNodeData.push({
            data: {
              source: parent,
              target: filterResult[i].node_ids,
              related_words:
                filterResult[i].node_relation_words === ""
                  ? ""
                  : filterResult[i].node_relation_words.replace(/\//g, ", "),
              label:
                "Edge from " +
                String(parent) +
                " to " +
                String(filterResult[i].node_ids),
              line: j,
              node_similarity: filterResult[i].node_similarity,
              type: "type" + j,
            },
          });
          break;
        }
      }
    }

    const expendedData = networkData.find((node) => node.data.id === parent);
    expendedData.data.expand = 1; // change target node's expand status to 1 (=expanded)

    setParent("");
    setNodeInfo([]);
    if (count === "push") {
      setNetworkDataStorage(networkDataStorage.concat(tempNodeData));
      setNetworkData(networkDataStorage.concat(tempNodeData));
      setTempNodeDataStorage(tempNodeData);
    } else {
      setNetworkData(networkData.concat(tempNodeData));
      setNetworkDataStorage(networkData.concat(tempNodeData));
    }

    setSelect(false);
    setLayoutName(layout);
  }
  async function createEdges(parentId) {
    try {
      let nodeInfo = await getDataJacketNodeDetail(parentId, user);
      if (undefined !== nodeInfo && nodeInfo.node_ids !== "") {
        myRef.current.elements("node").lock();
        setSelect(true);
        setParent(parentId);
        var objNodeInfo = createObject(nodeInfo, [
          "node_ids",
          "node_names",
          "node_raw_datas",
          "node_relation_words",
          "node_similarity",
        ]);
        setNodeInfo(sortObject(objNodeInfo, "node_similarity", "desc"));
      }
    } catch (e) {}
  }

  // Get Data Jacket Detail from Database
  async function getDataJacket(objId) {
    API.graphql(graphqlOperation(dataJacket, { id: objId }))
      .then((evt) => {
        //Change DateTime Format before assign
        evt.data.dataJacket.body.data_jacket_date_published =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_published
          );
        evt.data.dataJacket.body.data_jacket_date_update =
          convertDateTimeToDate(
            evt.data.dataJacket.body.data_jacket_date_update
          );
        setDetail(evt.data.dataJacket.body);
      })
      .catch((evt) => {});
  }

  // Get Data Jacket Detail from Database
  async function getDataJacketMy(objId) {
    API.graphql(graphqlOperation(myDataJacketList, { myDataJacketId: objId }))
      .then((evt) => {
        //Change DateTime Format before assign
        evt.data.myDataJacketList.body.update_date = convertDateTimeToDate(
          evt.data.myDataJacketList.body.update_date
        );
        setMyDetail(evt.data.myDataJacketList.body);
        setDetail(evt.data.myDataJacketList.body);
      })
      .catch((evt) => {});
  }

  // Show Data Jacket Detail on the right panel
  function showDetail(dataJacketId) {
    myRef.current.elements("node").lock();
    removeElementsByClass("popper-div", 0);
    // 百万の位（1の位から数えて7番目）の文字が '0' かどうかを確認する
    const digitAtMillion = dataJacketId.charAt(dataJacketId.length - 7);
    if (digitAtMillion === "0") {
      getDataJacket(dataJacketId);
    } else {
      getDataJacketMy(dataJacketId);
    }
  }

  // Delete nodes include clicked node, cannot be restore
  async function deleteNode(targetId) {
    myRef.current.elements("node").lock();
    const parent = networkDataStorage.find((node) => node.data.id === targetId)
      .data.parentId;
    let remain = networkDataStorage.filter(
      (node) =>
        (node.data.source !== undefined &&
          node.data.source !== targetId &&
          node.data.target !== targetId) ||
        (node.data.level !== undefined &&
          node.data.parentId !== targetId &&
          node.data.id !== targetId) ||
        node.data.level === 1
    );

    if (remain.filter((e) => e.data.parentId === parent).length < 1) {
      const expendedData = remain.find((node) => node.data.id === parent);
      expendedData.data.expand = 0;
    }

    let fold = setNodePosition(networkDataStorage).filter(
      (node) => !remain.includes(node)
    );
    var loopFold = [];
    while (loopFold.length !== fold.length) {
      loopFold = fold;
      loopFold.forEach(function (v) {
        var addition = remain.filter(
          (node) =>
            node.data.parentId === v.data.id ||
            node.data.source === v.data.id ||
            node.data.target === v.data.id
        );
        addition = addition.filter((node) => !fold.includes(node));
        if (addition.length > 0) {
          fold = fold.concat(addition);
        }
      });
    }
    remain = networkDataStorage.filter((node) => !fold.includes(node));
    let remain1 = networkData.filter((node) => !fold.includes(node));
    setNetworkData(remain1);
    setNetworkDataStorage(remain);
    setLayoutName(layout);
  }

  // Hide child nodes - nodes can be restored
  async function hideChildNode(targetId) {
    try {
      myRef.current.elements("node").lock();
      let remain = networkDataStorage.filter(
        (node) =>
          (node.data.source !== undefined && node.data.source !== targetId) ||
          (node.data.level !== undefined && node.data.parentId !== targetId) ||
          node.data.level === 1
      );

      let fold = setNodePosition(networkDataStorage).filter(
        (node) => !remain.includes(node)
      );
      var loopFold = [];
      while (loopFold.length !== fold.length) {
        loopFold = fold;
        loopFold.forEach(function (v) {
          var addition = remain.filter(
            (node) =>
              node.data.parentId === v.data.id ||
              node.data.source === v.data.id ||
              node.data.target === v.data.id
          );
          addition = addition.filter((node) => !fold.includes(node));
          if (addition.length > 0) {
            fold = fold.concat(addition);
          }
        });
      }

      remain = networkDataStorage.filter((node) => !fold.includes(node));
      fold = fold.map((node) => ({ ...node, foldId: targetId }));

      const expendedData = remain.find((node) => node.data.id === targetId);
      expendedData.data.expand = 2;

      let networkDataNew = [];
      for (let j = 1; j < Object.keys(visibleEdgeTypes).length + 1; j++) {
        const checkboxKey = "checkbox" + j;
        const checkboxValue = visibleEdgeTypes[checkboxKey];
        for (let i = 0; i < remain.length; i++) {
          if (remain[i].data.level !== undefined) {
            networkDataNew.push(remain[i]);
          }
          if (remain[i].data.type === checkboxValue) {
            networkDataNew.push(remain[i]);
          }
        }
      }
      let uniqueArray = [networkDataNew[0]]; // 最初の要素を新しい配列に追加
      uniqueArray = [...new Set(networkDataNew)];
      setNetworkData(uniqueArray);
      setFoldNode(foldNode.concat(fold));
      setLayoutName(preset);
      setNetworkDataStorage(remain);
    } catch (e) {}
  }

  // Restore hidden nodes
  async function restoreChildNode(targetId) {
    try {
      myRef.current.elements("node").lock();
      let restore = foldNode.filter((node) => node.foldId === targetId);
      let fold = foldNode.filter((node) => node.foldId !== targetId);
      restore.forEach(function (v) {
        delete v.foldId;
      });
      restore = setNodePosition(networkDataStorage).concat(restore);

      const expendedData = restore.find((node) => node.data.id === targetId);
      expendedData.data.expand = 1;
      recover();
      setFoldNode(fold);
      setNetworkData(restore);
      setNetworkDataStorage(restore);
      setLayoutName(preset);
      setFirstLoad(true);
    } catch (e) {}
  }

  function unfoldRestoreChildNode(targetId) {
    try {
      setUnfoldId(targetId);
    } catch (e) {}
  }

  function removeElementsByClass(className, length) {
    try {
      const elements = document.getElementsByClassName(className);
      while (elements.length > length) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    } catch (e) {}
  }

  function getTimeStr() {
    let now = new Date();
    let year = now.getFullYear();
    let month = ("0" + (now.getMonth() + 1)).slice(-2);
    let day = ("0" + now.getDate()).slice(-2);
    let hour = ("0" + now.getHours()).slice(-2);
    let minute = ("0" + now.getMinutes()).slice(-2);
    let second = ("0" + now.getSeconds()).slice(-2);
    return year + month + day + "_" + hour + minute + second;
  }

  const handleSaveImage = () => {
    if (myRef.current) {
      // ネットワーク図をPNG画像として保存
      const pngData = myRef.current.png({ output: "blob", full: true });

      // 画像を保存するためにブラウザ内でダウンロードリンクを生成
      const blobUrl = window.URL.createObjectURL(pngData);
      const anchor = document.createElement("a");
      anchor.href = blobUrl;
      anchor.download =
        "CONNECT_DJ_" + myRef.nodeLabel + "_" + getTimeStr() + ".png";
      anchor.click();

      // URLオブジェクトを解放
      window.URL.revokeObjectURL(blobUrl);
    }
  };

  const handleSaveButton = () => {
    const imageData = myRef.current.png();
    const base64Data = imageData.replace(/^data:image\/png;base64,/, "");
    setSaveImage(base64Data);
    setAnswerYes(true);
    setAnswerNo(true);
    setOpenRegister(true);
    setDisplay(false);
  };

  React.useEffect(() => {
    if (mode !== "redirect" && mode !== "saved") {
      createElements();
    }
    checkUser();
  }, [arrNetworkData]);

  React.useEffect(() => {
    const handleBeforeUnload = (event) => {
      // リロードが検知された場合に画面遷移
      navigate("/graph"); // '/target-route' は遷移したいルートに置き換えてください
    };

    // ページ遷移時にイベントリスナーを追加
    window.addEventListener("beforeunload", handleBeforeUnload);

    // コンポーネントがアンマウントされたときにイベントリスナーを削除
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [navigate]);

  React.useEffect(() => {
    try {
      if (answerYes === true) {
        if (networkData.length > 1) {
        }
      } else {
        setDisplay(true);
        getTempData1();
      }
    } catch {}
  }, [answerYes]);

  React.useEffect(() => {
    try {
      if (answerNo === true) {
        if (networkData.length > 1) {
        }
      } else {
        setDisplay(true);
        getTempData();
      }
    } catch {}
  }, [answerNo]);

  React.useEffect(() => {
    if (user !== "" && user !== undefined && mode === "redirect") {
      if (tempFlg === true) {
        //MYDATAからネットワーク図初期表示に使用
        getTempData2();
      } else {
        getTempData();
      }
    }
  }, [mode, user]);

  React.useEffect(() => {
    if (user === "" || user === undefined) {
      checkUser();
    }
    if (newFlag === true && networkData.length > 1) {
      handleSave();
      setInnerMode("redirect");
    }
    if (newFlag === false) {
      if (
        mode !== "redirect" &&
        mode !== "saved" &&
        (innerMode !== "redirect" ||
          (innerMode === "redirect" && mode !== "cancel"))
      ) {
        createElements();
      } else if (innerMode === "redirect" && mode !== "createnew") {
        getTempData();
      }
    }
  }, [newFlag]);

  React.useEffect(() => {
    if (
      detail.data_jacket_id !== undefined &&
      detail.data_jacket_id !== "" &&
      detail !== null &&
      open === false
    ) {
      handleOpen();
    } else if (
      myDetail.my_data_jacket_id !== undefined &&
      myDetail.my_data_jacket_id !== "" &&
      myDetail !== null &&
      open === false
    ) {
      handleOpen();
    }
    try {
      myRef.current.center();
      myRef.current.ready(
        setTimeout(() => {
          myRef.current.elements("node").unlock();
        }, "1000")
      );
    } catch (e) {}
  }, [detail, myDetail]);

  React.useEffect(() => {
    try {
      if (select === false && networkData.length > 0) {
        myRef.current.ready(
          setTimeout(() => {
            setLayoutName(preset);
            if (
              visibleEdgeTypes.checkbox1 !== "" &&
              visibleEdgeTypes.checkbox2 !== "" &&
              visibleEdgeTypes.checkbox3 !== "" &&
              visibleEdgeTypes.checkbox4 !== "" &&
              visibleEdgeTypes.checkbox5 !== ""
            ) {
              myRef.current.elements("node").unlock();
            } else {
            }
          }, "2000")
        );
      }
    } catch (e) {}
  }, [networkData]);
  React.useEffect(() => {
    try {
      setLayoutName(preset);
      if (
        visibleEdgeTypes.checkbox1 !== "" &&
        visibleEdgeTypes.checkbox2 !== "" &&
        visibleEdgeTypes.checkbox3 !== "" &&
        visibleEdgeTypes.checkbox4 !== "" &&
        visibleEdgeTypes.checkbox5 !== ""
      ) {
      } else {
        myRef.current.elements("node").lock();
      }
      let networkDataNew = [];
      for (let j = 1; j < Object.keys(visibleEdgeTypes).length + 1; j++) {
        const checkboxKey = "checkbox" + j;
        const checkboxValue = visibleEdgeTypes[checkboxKey];
        for (let i = 0; i < networkDataStorage.length; i++) {
          if (networkDataStorage[i].data.level !== undefined) {
            networkDataNew.push(networkDataStorage[i]);
          }
          if (networkDataStorage[i].data.type === checkboxValue) {
            networkDataNew.push(networkDataStorage[i]);
          }
        }
      }

      // 配列をSetに変換して重複を削除

      let uniqueArray = [networkDataNew[0]]; // 最初の要素を新しい配列に追加
      uniqueArray = [...new Set(networkDataNew)];

      // 新しい配列をuseStateで保存
      setNetworkData(uniqueArray);
    } catch (e) {}
  }, [visibleEdgeTypes]);

  React.useEffect(() => {
    try {
      recover();
    } catch (e) {}
  }, [tempNodeDataStorage]);

  React.useEffect(() => {
    try {
      if (open === false) {
        document.documentElement.style.setProperty("--right-position", "0");
        myRef.current.container().style.width = "97vw";
      } else {
        //current
        document.documentElement.style.setProperty("--right-position", "50vw");
        myRef.current.container().style.width = "50vw";
      }
      myRef.current.resize();
      myRef.current.center();
      myRef.current.ready(
        setTimeout(() => {
          myRef.current.elements("node").unlock();
        }, "1000")
      );
    } catch (e) {}
  }, [open]);

  var options = {
    // Customize event to bring up the context menu
    // Possible options https://js.cytoscape.org/#events/user-input-device-events
    evtType: ["cxttap"],
    // List of initial menu items
    // A menu item must have either onClickFunction or submenu or both
    menuItems: [
      {
        id: "hideNode",
        content: "ノード折り畳み",
        tooltipText: "ノード折り畳み",
        // selector: "node[expand=1]",
        selector: "node[expand=0],node[expand=1],node[expand=2]",
        //coreAsWell: true,
        onClickFunction: function (e) {
          hideChildNode(e.target.id());
        },
      },
      {
        id: "unhideNode",
        content: "ノード折り畳み解除",
        tooltipText: "ノード折り畳み解除",
        selector: "node[expand=0],node[expand=1],node[expand=2]",
        onClickFunction: function (e) {
          if (
            visibleEdgeTypes.checkbox1 !== "" &&
            visibleEdgeTypes.checkbox2 !== "" &&
            visibleEdgeTypes.checkbox3 !== "" &&
            visibleEdgeTypes.checkbox4 !== "" &&
            visibleEdgeTypes.checkbox5 !== ""
          ) {
            setRestoreflg(false);
            restoreChildNode(e.target.id());
          } else {
            setRestoreflg(true);
          }
          unfoldRestoreChildNode(e.target.id());
        },
      },
      {
        id: "expandNode",
        content: "ノード展開",
        tooltipText: "ノード展開",
        selector: "node[expand=0],node[expand=1],node[expand=2]",
        onClickFunction: function (e) {
          createEdges(e.target.id());
          if (
            visibleEdgeTypes.checkbox1 !== "" &&
            visibleEdgeTypes.checkbox2 !== "" &&
            visibleEdgeTypes.checkbox3 !== "" &&
            visibleEdgeTypes.checkbox4 !== "" &&
            visibleEdgeTypes.checkbox5 !== ""
          ) {
            setOpenComfirm(false);
          } else {
            setOpenComfirm(true);
          }
        },
      },
      {
        id: "checkInfo",
        content: "ノード情報確認",
        tooltipText: "ノード情報確認",
        image: { src: "add.svg", width: 12, height: 12, x: 6, y: 4 },
        selector: "node",
        onClickFunction: function (e) {
          // Delete popper before open modal window
          for (let i = 0; i < myRef.current._private.elements.length; i++) {
            if (myRef.current._private.elements[i].popperRefObj) {
              myRef.current._private.elements[i].popperRefObj.destroy();
            }
          }
          // Trigger open modal flag
          showDetail(e.target.id());
        },
      },
      {
        id: "deleteNode",
        content: "ノード削除",
        tooltipText: "ノード削除",
        image: { src: "add.svg", width: 12, height: 12, x: 6, y: 4 },
        selector: "node[level=2],node[level=3]",
        onClickFunction: function (e) {
          if (e.target._private.data.level !== 1) {
            deleteNode(e.target.id());
          }
        },
      },
    ],
    // css classes that menu items will have
    menuItemClasses: [
      // add class names to this list
      "custom-menu-item",
      "custom-menu-item:hover",
    ],
    // css classes that context menu will have
    contextMenuClasses: [
      // add class names to this list
      "custom-context-menu",
    ],
    // Indicates that the menu item has a submenu. If not provided default one will be used
    submenuIndicator: {
      src: "assets/submenu-indicator-default.svg",
      width: 12,
      height: 12,
    },
  };

  var defaults = {
    container: false, // string | false | undefined. Supported strings: an element id selector (like "#someId"), or a className selector (like ".someClassName"). Otherwise an element will be created by the library.
    viewLiveFramerate: 0, // set false to update graph pan only on drag end; set 0 to do it instantly; set a number (frames per second) to update not more than N times per second
    thumbnailEventFramerate: 30, // max thumbnail's updates per second triggered by graph updates
    thumbnailLiveFramerate: false, // max thumbnail's updates per second. Set false to disable
    dblClickDelay: 200, // milliseconds
    removeCustomContainer: true, // destroy the container specified by user on plugin destroy
    rerenderDelay: 100, // ms to throttle rerender updates to the panzoom for performance
  };

  try {
    // Delete Popper when move mouse to other area
    document
      .getElementById("network-button-area")
      .addEventListener("mouseover", function () {
        if (
          undefined !== document.getElementById("network-button-area") &&
          undefined !== document.getElementsByClassName("popper-div")[0]
        ) {
          for (let i = 0; i < myRef.current._private.elements.length; i++) {
            if (myRef.current._private.elements[i].popperRefObj) {
              myRef.current._private.elements[i].popperRefObj.destroy();
            }
          }
          removeElementsByClass("popper-div", 0);
        }
      });
  } catch (e) {}

  return (
    <span>
      <Box
        style={{
          display: "flex",
          position: "relative",
          minWidth: "1200px",
        }}
      >
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="flex-end"
          alignItems="right"
          id="network-button-area"
        >
          <Grid item style={{ marginTop: "12px" }}>
            <CssDataJacketButton
              variant="contained"
              size="large"
              color="success"
              style={{ width: "150px" }}
              onClick={handleSaveImage}
            >
              画像出力
            </CssDataJacketButton>
          </Grid>
          <Grid item style={{ marginTop: "12px" }}>
            <CssDataJacketButton
              variant="contained"
              size="large"
              color="success"
              style={{ width: "150px" }}
              onClick={handleSaveButton}
            >
              保存
            </CssDataJacketButton>
          </Grid>
          <Grid item style={{ marginTop: "12px" }}>
            <CssDataJacketButton
              variant="contained"
              size="large"
              color="success"
              style={{ width: "150px" }}
              onClick={(e) => {
                removeElementsByClass("cytoscape-navigator", 0);
                setDisplay(false);
                setOpen(false);
                setNew(!newFlag);
              }}
            >
              新規
            </CssDataJacketButton>
          </Grid>
          <Grid item>
            <DataNetworkUsageGuide
              visibleEdgeTypes={visibleEdgeTypes}
              setVisibleEdgeTypes={setVisibleEdgeTypes}
              setCount={setCount}
            />
          </Grid>
        </Grid>
      </Box>
      {restoreflg && (
        <DataJacketComfirmModalUnfold
          open={restoreflg}
          setRestoreflg={setRestoreflg}
          restoreChildNode={restoreChildNode}
          unfoldId={unfoldId}
        />
      )}
      {open && (
        <DataNetworkDetailModal
          open={open}
          setOpen={setOpen}
          dataJacket={detail}
          saveNetwork={handleSave}
          parentRef={myRef}
          setNetworkData={setNetworkData}
        />
      )}
      {(visibleEdgeTypes.checkbox1 === "" ||
        visibleEdgeTypes.checkbox2 === "" ||
        visibleEdgeTypes.checkbox3 === "" ||
        visibleEdgeTypes.checkbox4 === "" ||
        visibleEdgeTypes.checkbox5 === "") &&
        openComfirm && (
          <DataJacketComfirmModal
            open={openComfirm}
            setOpenComfirm={setOpenComfirm}
            setOpenCancel={setOpenCancel}
          />
        )}
      {select && !openComfirm && openCancel && (
        <DataJacketSelectNodeModal
          open={select}
          setOpen={setSelect}
          nodeInfo={nodeInfo}
          displayFilterNode={displayFilterNode}
        />
      )}
      {openRegister && (
        <SendToMyConnectDj
          open={openRegister}
          setOpenRegister={setOpenRegister}
          setAnswerYes={setAnswerYes}
          setName={setName}
          setSummary={setSummary}
          name={name}
          summary={summary}
          myRef={myRef}
          user={user}
          networkData={networkData}
          setNodePosition1={setNodePosition1}
          foldNode={foldNode}
          setNetworkData={setNetworkData}
          saveImage={saveImage}
          setSavedId={setSavedId}
          savedId={savedId}
          setAnswerNo={setAnswerNo}
          connectId={id}
          visibleEdgeTypes={visibleEdgeTypes}
          networkDataStorage={networkDataStorage}
          setNetworkDataStorage={setNetworkDataStorage}
          continuousSaving={continuousSaving}
          setContinuousSaving={setContinuousSaving}
        />
      )}

      <Box style={{ display: "flex", position: "absolute" }}>
        {displayFlag && (
          <CytoscapeComponent
            id="cytoscape-area"
            elements={networkData}
            style={compnentStyle}
            stylesheet={stylesheet}
            layout={layout}
            wheelSensitivity={0.1}
            cy={(cy) => {
              try {
                cy.contextMenus(options);
                //popper
                cy.elements().unbind("mouseover");
                cy.elements().bind("mouseover", (event) => {
                  if (event.target._private.group === "edges") {
                    event.target.popperRefObj = event.target.popper({
                      content: () => {
                        let similarity =
                          event.target._private.data.node_similarity;
                        let content = document.createElement("div");
                        let inner =
                          "類似度：" +
                          parseFloat(similarity).toFixed(2) +
                          "<br/>共通単語：";
                        content.classList.add("popper-div");
                        inner += event.target._private.data.related_words;
                        content.innerHTML = inner;

                        document.body.appendChild(content);
                        return content;
                      },
                    });
                  }
                });

                cy.elements().unbind("mouseout");
                cy.elements().bind("mouseout", (event) => {
                  if (
                    event.target.popper &&
                    event.target._private.group === "edges"
                  ) {
                    event.target.popperRefObj.state.elements.popper.remove();
                    event.target.popperRefObj.destroy();
                  }
                });
                if (networkData.length == 1) {
                  cy.center();
                }
                if (layoutName !== "") {
                  if (
                    networkData.filter((node) => node.position !== undefined)
                      .length > 0 &&
                    firstLoad === true
                  ) {
                    cy.layout(layoutName).run();
                  } else {
                    cy.layout(layoutName).run();
                  }
                }
                cy.navigator(defaults);
                removeElementsByClass("cytoscape-navigator", 1); //remove previous navigator div
                myRef.current = cy;
                myRef.nodeLabel = networkData[0].data.label;
              } catch (e) {}
            }}
          />
        )}
      </Box>
    </span>
  );
}
